import { InjectionToken } from '@angular/core';
import { Converter } from '@spartacus/core';
import { ProductAttributeTable } from '../../../../core/model';
import { Occ } from '../../../../core/occ';
import { AssortmentTable } from '../models';

export const PRODUCT_ATTRIBUTE_TABLE_NORMALIZER = new InjectionToken<Converter<Occ.AttributeTable, ProductAttributeTable>>(
  'ProductAttributeTableNormalizer'
);

export const PRODUCT_ASSORTMENT_TABLE_NORMALIZER = new InjectionToken<Converter<Occ.Assortment, AssortmentTable>>(
  'ProductAssortmentNormalizer'
);
